var chunkToChildrenMap = {
	"1026": [
		3493,
		2588,
		9510,
		7816,
		1554,
		6774,
		1613
	],
	"2435": [
		5435,
		8725,
		1027
	],
	"3065": [
		5824,
		8304,
		9510,
		4199,
		4043,
		585,
		7089,
		7108,
		8757,
		960,
		599,
		4079
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));